import React, { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Tooltip } from 'components/atoms/tooltip';
import { copyToAll, copyToNext } from 'assets/icons';
import { IDraftForm, IDraftFormLease } from 'types/tep';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './styles.module.css';

interface IActionsProps {
  rowIndex: number;
}

const COPY_KEYS = ['company', 'email', 'plateNumber', 'startOn', 'endOn'];

export const Actions: FC<IActionsProps> = ({ rowIndex }) => {
  const { control, getValues, setValue, trigger } = useFormContext<IDraftForm>();

  const leases: IDraftFormLease[] | undefined = useWatch({ control, name: 'leases' });

  const copyToAllLeases = () => {
    const leases = getValues().leases;

    leases.forEach((_, index) => {
      if (index !== rowIndex) {
        Object.keys(leases[rowIndex]).forEach((key) => {
          if (COPY_KEYS.includes(key)) {
            setValue(`leases.${index}.${key}`, leases[rowIndex][key]);
          }
        });
      }
    });

    trigger();
  };

  const copyToNexLease = () => {
    const values = getValues().leases[rowIndex];

    Object.keys(values).forEach((key) => {
      if (COPY_KEYS.includes(key)) {
        setValue(`leases.${rowIndex + 1}.${key}`, values[key]);
      }
    });

    trigger();
  };

  return (
    <div className={styles.actions}>
      <Tooltip text="copy to all">
        <SvgWrapper width={24} height={24} details={copyToAll} onClick={copyToAllLeases} />
      </Tooltip>
      {leases && rowIndex !== leases.length - 1 && (
        <Tooltip text="copy to next">
          <SvgWrapper width={24} height={24} details={copyToNext} onClick={copyToNexLease} />
        </Tooltip>
      )}
    </div>
  );
};
